import { QuestionBlock } from 'components/questionBlock'
import qbs from 'components/questionBlock/questionBlock.module.scss'
import { StatisticsRow } from 'components/statistics/statisticsRow'
import React from 'react'
import { QuestionState } from 'components/questions'

interface StatisticProps {
  id: string
  title: string
  allOptions: [string, string, number, number, string?][]
  selectedAnswers: QuestionState
  correctAnswers: string[]
}

export function Statistic({
  id,
  title,
  allOptions,
  selectedAnswers,
  correctAnswers
}: StatisticProps) {
  return (
    <QuestionBlock id={id} question={title} description=''>
      <table className={`ui unstackable table ${qbs.table}`}>
        <tbody>
          {/* eslint-disable-next-line @typescript-eslint/no-unused-vars */}
          {allOptions.map(([key, translation, counts, relative, color]) => (
            <StatisticsRow
              key={key}
              value={relative}
              isActive={
                selectedAnswers &&
                selectedAnswers[id] &&
                (selectedAnswers[id] as Set<string>).has(key)
              }
              text={translation}
              color={color}
              isCorrect={correctAnswers.includes(key)}
            />
          ))}
        </tbody>
      </table>
    </QuestionBlock>
  )
}
